export const DEFAULT_LANGUAGE = 'en'
export const SUPPORTED_LANGUAGES = ['ar', 'bg', 'zh_TW', 'de', 'da', 'en', 'en_US', 'et', 'fi', 'fr', 'el', 'it', 'ja', 'ko', 'hr', 'lv', 'lt', 'nl', 'nl_BE', 'no', 'pl', 'pt', 'pt_BR', 'ro', 'sv', 'sk', 'sl', 'es', 'th', 'cs', 'tr', 'uk', 'hu', 'vi', 'sq', 'sr']
/** list of all the (supported?) countries */
export const COUNTRIES = ['QA', 'SA', 'KW', 'US', 'AE', 'AT', 'AU', 'BE', 'BG', 'BR', 'CA', 'CH', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GB', 'GR', 'HK', 'HR', 'HU', 'IE', 'IN', 'IT', 'JP', 'KR', 'LI', 'LT', 'LU', 'LV', 'MO', 'MT', 'MX', 'MY', 'NL', 'NO', 'NZ', 'PL', 'PT', 'RO', 'SE', 'SG', 'SI', 'SK', 'TH', 'TR', 'TW', 'UA', 'VN', 'ZA', 'AR', 'ID', 'IL']

export const CHINA_COUNTRIES = ['CN']
export const MME_POLLINTERVAL = 3000
export const MME_POLLTIMEOUT = 300000

export const ARABIC_LANGUAGE = 'ar'
export const RTL_COUNTRIES = ['AE']
